import { ModalBody } from '@kvika/modal';
import styled from 'styled-components';

export const StyledModalBody = styled(ModalBody)<{ isLoginWithElectronicID: boolean }>`
  white-space: ${({ isLoginWithElectronicID }) => (isLoginWithElectronicID ? 'normal' : 'pre-wrap')};
`;
